<template>
    <div class="section grey-card">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="6" class="d-flex flex-column align-center justify-center">
                    <h1 class="mb-2">Onboarding & Renewals</h1>
                    <p class="mb-10 text-center">A member’s journey begins the moment they join. Yabbr ensures that experience is smooth, branded, and consistent — right through to their renewal.</p>
                </v-col>
            </v-row>
            <v-row cols="12" justify="center">
                <v-col cols="12" md="2" v-for="item in items" :key="item.title">
                    <v-card class="pa-4 horizontal-cards fill-height">
                        <v-card-text><v-icon color="primary" class="d-flex align-center" size="30px" style="background-color: #bfe3ff; width: 40px; height: 40px; border-radius: 5px;">mdi-{{ item.icon }}</v-icon></v-card-text>
                        <v-card-title>
                            {{ item.title }}
                        </v-card-title>
                        <v-card-text>
                            {{ item.text }}
                        </v-card-text>
                    </v-card>

                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'WorkflowsEfficiency',
    data: () => ({
        items: [
            {
                'icon':'login',
                'title':'Automated Onboarding',
                'text':'Welcome campaigns that introduce new members, explain benefits, and guide them through first steps.',
            },
            {
                'icon': 'form-textbox-lock',
                'title': 'Member Portals',
                'text': 'White-labelled portals for renewals, account management, and receipts — no dev work required. Configurable workflows provide different experiences for different member tiers.'
            },
            {
                'icon': 'reload-alert',
                'title': 'Smart Renewal Reminders',
                'text': 'Automated SMS or Email reminders before expiry, with follow-ups or personalised offers for lapsed members.'
            }
        ]
    })
}
</script>

<style lang="scss">


hr {
    margin: 1em 0;
    width: 50%;
}

.horizontal-cards {
    v-card-title {
        font-size: 1.5em !important;
    }
    v-card-text {
        font-size: 1.2em !important;
        color: #bfe3ff
    }
}
</style>